import React from 'react';
import {
    Avatar,
    Box,
    Chip,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { FitnessCenterRounded } from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";
import { InvoiceStatus } from "../../../helper/enums/InvoiceStatus";

function renderStatusChip(status) {
    switch (status) {
        case "COMPLETED":
            return (
                <Chip
                    label="تکمیل شده"
                    size="small"
                    sx={{
                        fontWeight: 700,
                        borderRadius: 1.8,
                        bgcolor: 'rgba(16, 185, 129, 0.1)',
                        color: 'success.main',
                        border: '1px solid',
                        borderColor: 'rgba(16, 185, 129, 0.2)'
                    }}
                />
            );
        case "REFUNDED":
            return (
                <Chip
                    label="استرداد شده"
                    size="small"
                    sx={{
                        fontWeight: 700,
                        borderRadius: 1.8,
                        bgcolor: 'rgba(239, 68, 68, 0.1)',
                        color: 'error.main',
                        border: '1px solid',
                        borderColor: 'rgba(239, 68, 68, 0.2)'
                    }}
                />
            );
        default:
            return (
                <Chip
                    label={InvoiceStatus[status] || status || "موفق"}
                    size="small"
                    sx={{ fontWeight: 700, borderRadius: 1.8 }}
                />
            );
    }
}

function getTicket(transaction) {
    try {
        const items = transaction?.Serial?.Invoices?.[0]?.InvoiceSubscribe || [];
        const names = items.map(t => t?.Name).filter(Boolean);
        return names.join("، ") || "خدمات ورزشی";
    } catch (e) {
        return "خدمات ورزشی";
    }
}

function getPlace(transaction) {
    try {
        const items = transaction?.Serial?.Invoices?.[0]?.InvoiceSubscribe || [];
        const placeNames = items.map(t => t?.Place?.Name).filter(Boolean);
        return placeNames.join("، ") || "مجموعه ورزشی";
    } catch (e) {
        return "مجموعه ورزشی";
    }
}

const _ChargeTransactionTableRow = ({ row }) => {
    const user = row?.Serial?.Invoices?.[0]?.User;
    const status = row?.Serial?.Invoices?.[0]?.Status;
    const fullName = user?.FullName || "کارمند";

    return (
        <TableRow
            hover
            sx={{
                transition: 'background-color 0.15s ease',
                '&:last-child td, &:last-child th': { border: 0 }
            }}
        >
            {/* Avatar */}
            <TableCell>
                <Avatar
                    src={user?.Avatar?.Url}
                    alt={fullName}
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: 2,
                        bgcolor: 'primary.main',
                        fontSize: '0.85rem',
                        fontWeight: 700
                    }}
                >
                    {fullName.slice(0, 2)}
                </Avatar>
            </TableCell>

            {/* Name */}
            <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                    {fullName}
                </Typography>
            </TableCell>

            {/* Amount */}
            <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                    {toPriceWithComma(row?.Amount)}
                    <Typography component="span" variant="caption" sx={{ color: 'text.secondary', mr: 0.5 }}>
                        تومان
                    </Typography>
                </Typography>
            </TableCell>

            {/* Date */}
            <TableCell>
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                    {row?.CreatedDate ? new Date(row.CreatedDate).toLocaleDateString('fa-IR', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    }) : "—"}
                </Typography>
            </TableCell>

            {/* Status */}
            <TableCell>
                {renderStatusChip(status)}
            </TableCell>

            {/* Ticket */}
            <TableCell>
                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                    {getTicket(row)}
                </Typography>
            </TableCell>

            {/* Place */}
            <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <FitnessCenterRounded sx={{ fontSize: 16, color: 'text.secondary', opacity: 0.7 }} />
                    <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                        {getPlace(row)}
                    </Typography>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default _ChargeTransactionTableRow;
